import React from "react";
import {responsibilityApiTYpe} from "../../../../ticketsystem/API/request/responsibility.Api,interface";
import {WorkLogCommentItem} from "./WorkLogCommentItem";
import {TicketActivityRecord} from "../../../API/request/ticket.interface";

interface WorkLogCommentListProps {
    comments: TicketActivityRecord[];
    users?: responsibilityApiTYpe[];
    currentUserId?: number;
    Store: any
}

export const WorkLogCommentList = (props: WorkLogCommentListProps): JSX.Element => {

    const {comments, users, currentUserId, Store} = props;

    const userById: Record<number, responsibilityApiTYpe> = {};

    users?.forEach((user: responsibilityApiTYpe): void => {
        userById[user.id] = user;
    });

    if (comments.length === 0) {
        return (
            <div className="border rounded p-3 text-muted">
                Noch keine Kommentare vorhanden.
            </div>
        );
    }

    return (
        <div>
            {comments.map((comment: TicketActivityRecord): JSX.Element => (
                <WorkLogCommentItem
                    key={comment.id}
                    comment={comment}
                    user={userById[comment.fromUserId]}
                    isOwnComment={Number(comment.fromUserId) === Number(currentUserId)}
                    Store={Store}
                />
            ))}
        </div>
    );
};